export default __webpack_public_path__ + "static/bumpa-378bab0788bd941ceffbfa3967c6af54.png";